export default {
    types: [
        {
            id: 0,
            icon: 'mdi-package-variant-closed',
            title: 'Powder',
        },
        {
            id: 1,
            icon: 'mdi-package-variant-closed-plus',
            title: 'On-Order'
        },
    ],
}